import { motion } from 'framer-motion';

interface IProps {
  fieldLength: number;
  currentBlock: number;
  gameStatus: number;
  kickerIndex: number;
  kickedBlock: number;
  velocity: number;
}

const TnCGameSchema: React.FC<IProps> = ({
  fieldLength,
  currentBlock,
  gameStatus,
  kickerIndex,
  kickedBlock,
  velocity
}: IProps) => {
  // schema parameters calculation
  const isStarted = gameStatus !== 1;
  const forward = kickerIndex === 0;

  let ballPos = (velocity * (currentBlock - kickedBlock)) / fieldLength;
  if (ballPos > 1) {
    ballPos = 1;
  }

  const catchLength = 10000 / fieldLength;

  let ballCenter;
  if (forward) {
    ballCenter = 10 + ballPos * 250;
  } else {
    ballCenter = 260 - ballPos * 250;
  }

  const catchWidth = catchLength * 250;

  return (
    <motion.svg
      key="TnCGameSchemaSvg"
      xmlns="http://www.w3.org/2000/svg"
      width="270"
      height="24"
      viewBox="0 0 270 24"
      fill="none"
    >
      <defs>
        <linearGradient id="rectGradient" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="#13131a" stopOpacity="0" />
          <stop offset="50%" stopColor="#163A0F" stopOpacity="1" />
          <stop offset="100%" stopColor="#13131a" stopOpacity="0" />
        </linearGradient>
      </defs>

      <rect
        x={forward ? `${260 - catchWidth}` : '10'}
        y="0"
        rx="0"
        ry="0"
        width={`${catchWidth}`}
        height="24"
        fill="url(#rectGradient)"
      />

      <path
        stroke="#383838"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 10 0 L 10 24 M 10 12 L 260 12 M 260 0 L 260 24"
      />

      <path
        stroke="#1B4913"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d={
          forward
            ? `M ${260 - catchWidth} 12 L 260 12`
            : `M 10 12 L ${catchWidth} 12`
        }
      />

      {isStarted && (
        <motion.path
          key="TnCGameSchemaPath"
          initial={{
            pathLength: 0
          }}
          animate={{
            pathLength: 1
          }}
          transition={{
            duration: 3,
            ease: 'easeInOut',
            repeat: Infinity,
            repeatType: 'loop'
          }}
          stroke="#f8f8f8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          d={
            forward
              ? `M ${ballCenter} 12 L 260 12`
              : `M ${ballCenter} 12 L 10 12`
          }
        />
      )}

      <circle
        cx={`${ballCenter}`}
        cy="12"
        r="8"
        stroke="#f8f8f8"
        strokeWidth="2"
        fill="#13131a"
      />
    </motion.svg>
  );
};

export default TnCGameSchema;
